<template lang="pug">
.v-person-grid.person-grid(v-if="data" :class="[view ? 'person-grid--' + view : '']" :id="data?.id")
	.person-grid__title(v-if="data.title") {{data.title}}
	.person-grid__items
		.person-grid__item(v-for="(item, i) in data.items" @mouseenter="data.items[i].open = true" @mouseleave="data.items[i].open = false")
			.person-grid__item-banner(v-if="item.image")
				img.person-grid__item-img(:src="item.image.src" :alt="item.image.alt" fetchpriority="high")
			.person-grid__item-content
				.person-grid__item-title(v-if="item.title") {{item.title}}
				.person-grid__item-subtitle(v-if="item.subtitle") {{item.subtitle}}
				v-collapse(:open="isMob || item.open || !!view")
					.person-grid__item-actions(v-if="item.action")
						button.person-grid__item-action.btn.btn--gray.btn--sm(type="button" @click="active = item") {{item.action.text}}
	v-panel(:open-state="!!active" @close="active = null" :close-text="data.closeText" :body-class="'person-grid__panel-body'")
		template(#content)
			.person-grid__card
				.person-grid__card-head
					img.person-grid__card-img(v-if="active.image" :src="active.image.src" :alt="active.image.alt")
					.person-grid__card-head-inner
						.person-grid__card-title(v-if="active.title") {{active.title}}
						.person-grid__card-subtitle(v-if="active.subtitle") {{active.subtitle}}
				.person-grid__card-text.text-guide(v-if="active.text" v-html="active.text")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		view: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			data: null,
			active: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>